import React from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Grid, Box, Button, Divider } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { addFundAgentDispatch } from 'reducers/HomeReducer';
import {
	addCartRow,
	addCustomRow,
	addLostRow,
	addWonRow,
	toggleModal,
	toggleProductModal,
} from 'reducers/UiReducer';

const AddCustomField = () => {
	const { agentId, cart, tab, won, lost } = useSelector((state) => state.ui);
	const { loginInfo } = useSelector((state) => state.home);
	const dispatch = useDispatch();
	const handleFormSubmit = (data) => {
		let form = {
			name: data.name,
			value: data.value,
			type: data.type,
		};
		dispatch(addCustomRow(form));
		dispatch(toggleProductModal(false));

		// dispatch(toggleModal(false));
		// dispatch(addFundAgentDispatch(form, loginInfo));
	};
	return (
		<Formik
			initialValues={{
				amount: '',
			}}
			onSubmit={handleFormSubmit}>
			{(formik) => {
				const { errors, setFieldValue } = formik;
				return (
					<Form>
						<Box style={{}}>
							<Box
								style={{
									padding: 30,
									background: 'white',
								}}>
								<h2 style={{ fontSize: 20, textAlign: 'center' }}>
									Add Custom Field
								</h2>
								<Grid container style={{ marginTop: 10 }} spacing={1}>
									<Grid item xs={12} lg={12}>
										<label for='inputPassword5' class='form-label'>
											Name
										</label>
										<Field
											name='name'
											type='text'
											placeHolder='Enter Name'
											style={{
												border: errors?.name
													? '2px solid red'
													: '1px solid #e9edf6',
											}}
											className='form-control'
										/>
										{errors?.name ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors?.name}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12} lg={12}>
										<label for='inputPassword5' class='form-label'>
											Value
										</label>
										<Field
											name='value'
											type='text'
											placeHolder='Enter Value'
											style={{
												border: errors?.value
													? '2px solid red'
													: '1px solid #e9edf6',
											}}
											className='form-control'
										/>
										{errors?.value ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors?.value}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12} lg={12}>
										<label for='inputPassword5' class='form-label'>
											Type
										</label>
										<Field
											name='type'
											type='text'
											placeHolder='Enter Type'
											style={{
												border: errors?.type
													? '2px solid red'
													: '1px solid #e9edf6',
											}}
											className='form-control'
										/>
										{errors?.type ? (
											<span style={{ color: 'red', fontSize: 12 }}>
												{errors?.type}
											</span>
										) : null}
									</Grid>
									<Grid item xs={12} lg={6}>
										<Button
											type='submit'
											id='input-button'
											className='form-control btn btn-primary'
											style={{}}>
											Submit
										</Button>
									</Grid>
								</Grid>
							</Box>
						</Box>
					</Form>
				);
			}}
		</Formik>
	);
};

export default AddCustomField;
